import { render, staticRenderFns } from "./application-footer.vue?vue&type=template&id=00eadea2&scoped=true"
import script from "./application-footer.vue?vue&type=script&lang=js"
export * from "./application-footer.vue?vue&type=script&lang=js"
import style0 from "./application-footer.vue?vue&type=style&index=0&id=00eadea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00eadea2",
  null
  
)

export default component.exports